import React from 'react';
import {createRoot} from 'react-dom/client';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import GlobalStyles from '../main/GlobalStyles';

import Compatibility from './compatibility';
import ThemeProvider from 'components/ThemeProvider';
import ThemeSection from 'components/ThemeSection';
import getBaseTheme from 'styles/getBaseTheme';

const baseTheme = getBaseTheme();

function redirectOnContinue() {
	window.location.href = '/';
}

const container = document.getElementById('root');

if (container) {
	const root = createRoot(container);
	root.render(
		<ThemeProvider theme={baseTheme}>
			<ThemeSection name="page">
				<div id="app">
					<GlobalStyles />
					<Compatibility onContinue={redirectOnContinue} />
				</div>
			</ThemeSection>
		</ThemeProvider>
	);
}
